import engineer from "../assets/image/engineer.png";
import Entrance from "../assets/image/study3.png";
import looksewa from "../assets/image/lookswa.png";

export const courseName = [
  {
    id: 1,
    course: "प्रवेश प्रियोजना (Entrance Preparation)",
    image: Entrance,

    fields: [
      {
        id: 1,
        field: "Health Acescent(H.A)",
        path: "HA",
      },
      {
        id: 2,
        field: "Staff Nurse/Anomy",
        path: "staff-nurse",
      },
      {
        id: 3,
        field: "Diploma",
        path: "diploma",
      },
      {
        id: 4,
        field: " Science",
        path: "science",
      },
      {
        id: 5,
        field: "JTA",
        path: "jta",
      },
      {
        id: 6,
        field: "Veterinary",
        path: "veterinary",
      },
      {
        id: 7,
        field: "Accountant",
        path: "accountant",
      },
      {
        id: 8,
        field: "Computer",
        path: "computer",
      },
    ],
  },

  {
    id: 2,
    course: "लोक सेवा (Lok Sewa - Public Service)",
    image: looksewa,
    fields: [
      {
        id: 1,
        field: "Section Officer (सेक्शन अफिसर)",
        path: "section-officer",
      },
      {
        id: 2,
        field: "Nayab Subba (नायब सुब्बा) ",
        path: "nayab-subba",
      },
      {
        id: 3,
        field: "Kharidar (खरिदार)",
        path: "kharidar",
      },
      {
        id: 4,
        field: "Lekha (लेखा) ",
        path: "lekha",
      },
      {
        id: 5,
        field: " Assistant (सहायक)",
        path: "assistant",
      },
      {
        id: 6,
        field: "Sahayak Kharidar (सहायक खरिदार)  ",
        path: "sahayak-kharidar",
      },
      {
        id: 7,
        field: " Health Services (स्वास्थ्य सेवा) ",
        path: "health-services",
      },
      {
        id: 8,
        field: "Anchal Adhikrit (अंचल अधिकृत)",
        path: "anchal-adhikrit",
      },
      {
        id: 9,
        field: "Engineering Services (ईन्जिनियरिङ सेवा)",
        path: "engineering-services",
      },
      // {
      //   id: 10,
      //   field: "Non-Gazetted First Class (गैरसरकारी प्रथम श्रेणी) ",
      //   path: "Non-Gazetted First Class",
      // },
    ],
  },
  {
    id: 3,
    course: "सामान्य ज्ञान (GK - General Knowledge)",
    image: looksewa,
    fields: [
      {
        id: 1,
        field: "  Static GK",
        path: "Static-GK",
      },
      {
        id: 2,
        field: "History",
        path: "history",
      },
      {
        id: 3,
        field: " Geography",
        path: "geography",
      },
      {
        id: 4,
        field: "Polity",
        path: "polity",
      },
      {
        id: 5,
        field: " Economics",
        path: "economics",
      },
    ],
  },
  {
    id: 4,
    course: "इन्जिनियरिङ (Engineering):",
    image: engineer,
    fields: [
      {
        id: 1,
        field: "Civil Engineering",
        path: "civil-engineering",
      },
      {
        id: 2,
        field: "Electrical Engineering",
        path: "electrical-engineering",
      },
      {
        id: 3,
        field: "Mechanical Engineering",
        path: "mechanical-engineering",
      },
      {
        id: 4,
        field: "Electronics and Communication Engineering",
        path: "electronics&communication-engineering",
      },
    ],
  },
  {
    id: 5,
    course: "Licenses",
    image: looksewa,
    fields: [
      {
        id: 1,
        field: "Driving Licenses for vehicle",
        path: "driving-licenses",
      },
      {
        id: 2,
        field: "Health Acescent(H.A) Licenses",
        path: "HA-licenses",
      },
      {
        id: 3,
        field: "Engineering Licenses",
        path: "engineering-licenses",
      },
    ],
  },
  {
    id: 6,
    course: "सामान्य योग्यता (General Aptitude):",
    image: Entrance,
    fields: [
      {
        id: 1,
        field: " Aptitude",
        path: "aptitude",
      },
      {
        id: 2,
        field: "Reasoning",
        path: "reasoning",
      },
      {
        id: 3,
        field: " General Science",
        path: "general-science",
      },
      {
        id: 4,
        field: "English",
        path: "english",
      },
    ],
  },
  {
    id: 7,
    course: "कम्प्युटर (Computer)",
    image: Entrance,
    fields: [
      {
        id: 1,
        field: " Computer Fundamental",
        path: "computer-fundamental",
      },
      {
        id: 2,
        field: "Networking",
        path: "networking",
      },
      {
        id: 3,
        field: " Database Management System",
        path: "database-management-system",
      },
      {
        id: 4,
        field: " C Program",
        path: "c-program",
      },
    ],
  },
];





export const termAndCondition=[
  {
    title:"Introduction",
    paragraph:'Welcome to KizoStudy (“we,” “our,” “us”). These Terms and Conditions (“Terms,” “T&C”) govern your use of our website located at www.kizostudy.com (together or individually “Service”) operated by KizoStudy.'
  },
  {
    title:" Accounts",
    paragraph:'When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.'
  },
  {
    title:"User Content",
    paragraph:'Our Service allows users to create and upload content, including text and images. You are responsible for the content you upload and must ensure that it complies with all applicable laws and does not infringe on any third-party rights.'
  },
  {
    title:"Intellectual Property",
    paragraph:'The content, including but not limited to our logo, visual design, and trademarks, is our exclusive property. You may not use our intellectual property without our prior written consent.'
  },
  {
    title:" Questions and Course Content",
    paragraph:'The questions on this site are for quizzes and MCQ questions. We verify the questions to the best of our ability, but if you are affected by the course content in any way, we are not responsible. Our questions are collected from books, question banks, exam papers, and many other sources.'
  },
  {
    title:"Feedback and Suggestions",
    paragraph:'If you provide feedback and suggestions, we may use them without any obligation to compensate you or provide credit.'
  },
  {
    title:"Limitation of Liability",
    paragraph:'In no event shall KizoStudy, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.'
  },
  {
    title:"Governing Law",
    paragraph:'These Terms shall be governed and construed in accordance with the laws of nepal,and others., without regard to its conflict of law provisions.'
  },
  {
    title:"Changes to Terms",
    paragraph:'We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.'
  },
  {
    title:"Termination",
    paragraph:'We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.'
  },
  {
    title:"Contact Us",
    paragraph:'If you have any questions about these Terms, please contact us:'
  }
]








